"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsSettings = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const uiStyles_1 = require("../uiStyles");
let controls = [
    { Movement: [{ name: 'Up', key: 'W / Up Arrow' }, { name: 'Down', key: 'S / Down Arrow' }, { name: 'Left', key: 'A / Left Arrow' }, { name: 'Right', key: 'D / Right Arrow' }] },
    { Other: [
            { name: 'Emote', key: 'Q' },
            { name: 'Open Menu', key: 'G' },
            { name: 'Open Settings', key: 'O / Escape' }
        ] },
    { Actions: [{ name: 'Pickup Item / Interact', key: 'F / E' },
            { name: 'Attack 1', key: 'Left Mouse Button / 1' },
            { name: 'Attack 2', key: '2' }, { name: 'Attack 3', key: '3' }, { name: 'Attack 4', key: '4' },
            { name: 'Attack 5', key: 'Right Mouse Button / 5' },
            // {name: 'Attack 6', key: '6'}, {name: 'Attack 7', key: '7'}, {name: 'Attack 8', key: '8'}, {name: 'Attack 9', key: '9'}, {name: 'Attack 10', key: '0'}
        ] },
];
let controlsTable = controls.map((control) => {
    return Object.keys(control).map((key) => {
        return react_1.default.createElement(material_1.Grid, { container: true, item: true, xs: 12, alignItems: "center", justifyContent: "center" },
            react_1.default.createElement(material_1.Grid, { container: true, alignItems: "center", justifyContent: "center", item: true, xs: 12 },
                react_1.default.createElement("b", null, key)),
            react_1.default.createElement(material_1.Grid, { container: true, item: true, xs: 3 }),
            react_1.default.createElement(material_1.Grid, { container: true, item: true, xs: 6 },
                react_1.default.createElement(material_1.TableContainer
                // align='center'
                , { 
                    // align='center'
                    style: {
                        height: '100%',
                    } },
                    react_1.default.createElement(material_1.Table
                    // align='center'
                    , { 
                        // align='center'
                        style: {
                            paddingLeft: '3%',
                            paddingRight: '3%',
                            paddingBottom: '3%',
                        } }, control[key].map((item, i) => {
                        let backgroundColor;
                        if ((i % 2) == 0) {
                            backgroundColor = '#efd3bd';
                        }
                        else {
                            backgroundColor = '#d8bca7';
                        }
                        return react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(material_1.TableRow, { style: Object.assign({
                                    backgroundColor: backgroundColor,
                                    padding: '1px',
                                }, uiStyles_1.smallBorderProperties) },
                                react_1.default.createElement(material_1.TableCell, { align: 'center', style: {
                                        width: '50%',
                                        padding: '1px',
                                        borderColor: 'black'
                                    } }, item.name),
                                react_1.default.createElement(material_1.TableCell, { align: 'center', style: {
                                        width: '50%',
                                        padding: '1px',
                                        borderColor: 'black'
                                    } }, item.key)));
                    })))),
            react_1.default.createElement(material_1.Grid, { container: true, item: true, xs: 3 }));
    });
});
function ControlsSettings() {
    return react_1.default.createElement(material_1.Grid, { container: true, xs: 12, alignItems: "center", justifyContent: "center", style: {
        // maxHeight: '400px',
        // minHeight: '400px'
        } },
        react_1.default.createElement(material_1.Grid, { container: true, xs: 12, style: {
                maxHeight: '100%',
                overflow: 'auto',
            } }, controlsTable));
}
exports.ControlsSettings = ControlsSettings;
